// @flow

import React from "react";

import { ServiceManager } from "../service/service-manager";
import { RegisterContainer } from "./register-container";
import { isNZ } from "../domain-config";

type Props = {
  serviceManager: ServiceManager,
};

const webComponentHtml = `
        <script type="module" src="/web-components/web-components/web-components.esm.js"></script>
        <script nomodule="" src="/web-components/web-components/web-components.js"></script>
        <link rel="stylesheet" href="/web-components/web-components/web-components.css">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/material-design-iconic-font/2.2.0/css/material-design-iconic-font.min.css">

        <rg-section
          max-width="large"
          theme="muted"
          remove-padding
          id="learn-more"
        >
          <rg-section height="remove" text-align="center" id="learn-more">
            <h2>What can I do with my Reece account?</h2>
            <br />
          </rg-section>

          <rg-section height="remove" remove-padding>
            <rg-grid gap="remove">
              <rg-grid-item max-width="1-1 1-2@s">
                <rg-section
                  height="medium"
                  align-horizontal="center"
                  max-width="xxsmall"
                >
                  <div style="max-width: 330px">
                    <img
                      src="//www.reece.com.au/site-assets/Component-pages/Retail-Registration/icon-checklist.png"
                      alt="Checklist Icon"
                    />
                    <h3>
                      Access your in-store quotes and turn them into orders
                    </h3>
                    <rg-text-lead>
                      <p>
                        Turn your quote into reality and order your new
                        bathroom.
                      </p>
                    </rg-text-lead>
                  </div>
                </rg-section>
              </rg-grid-item>
              <rg-grid-item max-width="1-1 1-2@s">
                <rg-cover min-height="250px">
                  <img
                    src="//www.reece.com.au/site-assets/Component-pages/Retail-Registration/reece-branch-assistant-smiling2x.jpg"
                    alt="Reece female branch assistant smiling"
                  />
                </rg-cover>
              </rg-grid-item>
            </rg-grid>

            <rg-grid gap="remove">
              <rg-grid-item max-width="1-1 1-2@s">
                <rg-section
                  height="medium"
                  align-horizontal="center"
                  max-width="xxsmall"
                >
                  <div style="max-width: 330px">
                    <img
                      src="//www.reece.com.au/site-assets/Component-pages/Retail-Registration/icon-receipt.png"
                      alt="Receipt Icon"
                    />
                    <h3>Browse your purchase history</h3>
                    <rg-text-lead>
                      <p>
                        One central spot to easily reference all your past
                        purchases.
                      </p>
                    </rg-text-lead>
                  </div>
                </rg-section>
              </rg-grid-item>
              <rg-grid-item max-width="1-1 1-2@s" flex-order="first@s">
                <rg-cover min-height="250px">
                  <img
                    src="//www.reece.com.au/site-assets/Component-pages/Retail-Registration/reece-order-history-phone-hand2x.jpg"
                    alt="Person holding mobile phone displaying Reece order history"
                  />
                </rg-cover>
              </rg-grid-item>
            </rg-grid>

            <rg-grid gap="remove">
              <rg-grid-item max-width="1-1 1-2@s">
                <rg-section
                  height="medium"
                  align-horizontal="center"
                  max-width="xxsmall"
                >
                  <div style="max-width: 330px">
                    <img
                      src="//www.reece.com.au/site-assets/Component-pages/Retail-Registration/icon-stack.png"
                      alt="Icon Stack"
                    />
                    <h3>Save your Imagin3D and Moodboard concepts</h3>
                    <rg-text-lead>
                      <p>
                        Keep your inspiration together, create separate ideas,
                        and come back where you left off.
                      </p>
                      <rg-button type="text" priority="secondary">
                        <a href="//www.reece.com.au/bathrooms/bathroom-planning">
                          Imagin3D
                        </a>
                      </rg-button>
                      <rg-button type="text" priority="secondary">
                        <a href="//www.reece.com.au/moodboard">Moodboard Tool</a>
                      </rg-button>
                    </rg-text-lead>
                  </div>
                </rg-section>
              </rg-grid-item>
              <rg-grid-item max-width="1-1 1-2@s">
                <rg-cover min-height="250px">
                  <img
                    src="//www.reece.com.au/site-assets/Component-pages/Retail-Registration/reece-mood-board-tool2x.jpg"
                    alt="Reece Mood Board Tool screenshot"
                  />
                </rg-cover>
              </rg-grid-item>
            </rg-grid>
          </rg-section>
        </rg-section>
`;

export class RegisterPage extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);
  }
  render = () => {
    return (
      <div className="register-page">
        <div className="content-container">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12 col-sm-7 col-md-6 col-lg-6 col-sm-push-5 col-md-push-6">
                <div className="register-page__section-register">
                  <div className="row register-page__section-register-back-link">
                    <a
                      href={
                        isNZ ? "/create-trade-account" : "/trade/create-account"
                      }
                    >
                      ← Trade Customer?
                    </a>
                  </div>
                  <h1 className="register-page__section-register-header">
                    Register
                  </h1>
                  <RegisterContainer
                    serviceManager={this.props.serviceManager}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-sm-5 col-md-6 col-lg-6 col-sm-pull-7 col-md-pull-6">
                <div className="register-page__section-image"></div>
              </div>
            </div>
          </div>
        </div>
        <div dangerouslySetInnerHTML={{ __html: webComponentHtml }} />
      </div>
    );
  };
}
